import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useCart } from '../../context/CartContext';

// Botón flotante del carrito (fijo abajo-derecha). Lleva a /cart. Mantiene las
// clases floating-cart-* para la animación "vuela al carrito".
const FloatingCartButton = () => {
    const { items, total } = useCart();
    const navigate = useNavigate();
    const location = useLocation();

    const itemCount = items.reduce((count, item) => count + (item.quantity || 0), 0);

    const hiddenPaths = ['/login', '/thank-you', '/payment', '/order-type', '/payment-method', '/operate-card', '/cart'];
    if (hiddenPaths.includes(location.pathname)) return null;

    return (
        <div className="floating-cart-container" style={{ position: 'fixed', bottom: 24, right: 24, zIndex: 50 }}>
            <button
                onClick={() => navigate('/cart')}
                className="floating-cart-button"
                style={{
                    display: 'flex', alignItems: 'center', gap: 16, padding: '20px 32px',
                    background: '#009542', color: '#fff', border: 'none', borderRadius: 999,
                    boxShadow: '0 14px 34px rgba(0,0,0,0.38)', cursor: 'pointer', position: 'relative'
                }}
            >
                <span style={{ position: 'relative', display: 'flex', alignItems: 'center' }}>
                    <svg width="46" height="46" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round"
                            d="M3 3h2l.4 2M7 13h10l4-8H5.4M7 13L5.4 5M7 13l-2.293 2.293c-.63.63-.184 1.707.707 1.707H17m0 0a2 2 0 100 4 2 2 0 000-4zm-8 2a2 2 0 11-4 0 2 2 0 014 0z" />
                    </svg>
                    {itemCount > 0 && (
                        <span style={{
                            position: 'absolute', top: -12, right: -14, minWidth: 30, height: 30, padding: '0 7px',
                            borderRadius: 15, background: '#fff', color: '#009542', fontWeight: 900, fontSize: 16,
                            display: 'flex', alignItems: 'center', justifyContent: 'center'
                        }}>
                            {itemCount > 99 ? '99+' : itemCount}
                        </span>
                    )}
                </span>
                {total > 0 && (
                    <span style={{ fontWeight: 900, fontSize: '1.5rem' }}>${total.toLocaleString('es-CL')}</span>
                )}
            </button>
        </div>
    );
};

export default FloatingCartButton;
